import type { ReactNode } from 'react'
import classes from '../styles/crmIntegrationChat.module.css'

const URL_REGEXP = /(https?:\/\/[^\s<>"'()]+)/gi
const TRAILING_PUNCTUATION_REGEXP = /[.,!?;:)]+$/

const splitUrlMatch = (match: string): { href: string; trailing: string } => {
  const punctMatch = match.match(TRAILING_PUNCTUATION_REGEXP)
  if (!punctMatch) {
    return { href: match, trailing: '' }
  }

  return {
    href: match.slice(0, -punctMatch[0].length),
    trailing: punctMatch[0],
  }
}

/** Текст пузыря с кликабельными http(s)-ссылками (Wazzup VK-video URL и т.п.). */
export const renderCrmIntegrationMessageText = (text: string): ReactNode => {
  const source = text.trim()
  if (!source) {
    return null
  }

  const nodes: ReactNode[] = []
  let lastIndex = 0
  let match: RegExpExecArray | null

  URL_REGEXP.lastIndex = 0
  while ((match = URL_REGEXP.exec(source)) != null) {
    const offset = match.index
    if (offset > lastIndex) {
      nodes.push(source.slice(lastIndex, offset))
    }

    const { href, trailing } = splitUrlMatch(match[0])
    if (href) {
      nodes.push(
        <a
          key={`url-${offset}-${href}`}
          className={classes.bubbleTextLink}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
        >
          {href}
        </a>,
      )
    }

    if (trailing) {
      nodes.push(trailing)
    }

    lastIndex = offset + match[0].length
  }

  if (lastIndex < source.length) {
    nodes.push(source.slice(lastIndex))
  }

  return nodes.length > 0 ? nodes : source
}
